module.exports = __webpack_public_path__ + "fonts/SamsungOne-700v10.841cdb18.otf";